module.exports = new __parcel__URL__("mid-tom_4.72bb4506.mp3").toString();